__turbopack_context__.v({
  "container": "kM1U1W_container",
  "desktop-image": "kM1U1W_desktop-image",
  "hero-reveal": "kM1U1W_hero-reveal",
  "mobile-image": "kM1U1W_mobile-image",
  "perk": "kM1U1W_perk",
  "perk-text": "kM1U1W_perk-text",
  "perk-title": "kM1U1W_perk-title",
  "perks": "kM1U1W_perks",
  "perks-bullets": "kM1U1W_perks-bullets",
  "perks-header": "kM1U1W_perks-header",
  "perks-header-smalltext": "kM1U1W_perks-header-smalltext",
  "perks-header-title": "kM1U1W_perks-header-title",
  "professional": "kM1U1W_professional",
  "support": "kM1U1W_support",
  "thoughtfull": "kM1U1W_thoughtfull",
});
